import { FC } from 'react';

import { IconProps } from '../types';

export const PaperTextIcon: FC<IconProps> = ({
	size,
	height = 24,
	width = 24,
	color = '#06519E',
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={size ?? width}
		height={size ?? height}
		viewBox="0 0 24 24"
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M6 23h12c1.654 0 3-1.35 3-3V7.5c0-.26-.105-.52-.293-.71l-5.5-5.5A1.027 1.027 0 0 0 14.5 1H6C4.346 1 3 2.35 3 4v16c0 1.65 1.346 3 3 3Zm7-20H6c-.551 0-1 .45-1 1v16c0 .55.449 1 1 1h12c.552 0 1-.45 1-1V9h-5c-.553 0-1-.45-1-1V3Zm5.086 4H15V3.91L18.086 7Z"
		/>
		<path
			fill={color}
			fillRule="evenodd"
			d="M17 14.5a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2h10Zm-5-3a1 1 0 0 1 0 2H7a1 1 0 0 1 0-2h5Zm5 6a1 1 0 1 1 0 2H7a1 1 0 0 1 0-2h10Z"
		/>
	</svg>
);
